var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ChartTraits from "./ChartTraits";
import TimeVaryingTraits from "./TimeVaryingTraits";
let DiscretelyTimeVaryingTraits = (_dec = primitiveTrait({
  name: "Mapping from Continuous Time",
  description: "Specifies how a continuous time (e.g. the timeline control) is mapped to a discrete time for this dataset. Valid values are: <br/>" + " * `nearest` - the nearest available discrete time to the current continuous time is used. <br/>" + " * `next` - the discrete time equal to or after the current continuous time is used. <br/>" + " * `previous` - the discrete time equal to or before the current continuous time is used.",
  type: "string"
}), _dec2 = primitiveTrait({
  type: "boolean",
  name: "Show in chart",
  description: "Whether to plot data availability on a chart."
}), _dec3 = primitiveTrait({
  type: "boolean",
  name: "Disable date time selector",
  description: "When true, disables the date time selector in the workbench"
}), _dec4 = primitiveTrait({
  name: "Time Multiplier",
  description: "The multiplierDefaultDeltaStep is used to set the default multiplier (see `TimeVaryingTraits.multiplier` trait) - it represents the average number of (real-time) seconds between (dataset) time steps. For example, a value of five would set the `multiplier` so that a new time step (of this dataset) would appear every five seconds (on average) if the timeline is playing. This trait will only take effect if `multiplier` is **not** explicitly set.",
  type: "number"
}), _class = class DiscretelyTimeVaryingTraits extends mixTraits(ChartTraits, TimeVaryingTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "fromContinuous", _descriptor, this);
    _initializerDefineProperty(this, "showInChartPanel", _descriptor2, this);
    _initializerDefineProperty(this, "disableDateTimeSelector", _descriptor3, this);
    _initializerDefineProperty(this, "multiplierDefaultDeltaStep", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "fromContinuous", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "nearest";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showInChartPanel", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "disableDateTimeSelector", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "multiplierDefaultDeltaStep", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 2;
  }
}), _class);
export { DiscretelyTimeVaryingTraits as default };